import { memo } from 'react'

import { githubAuthURL, googleAuthURL, jiraAuthURL, stripeAuthURL } from 'static/metadata'

import { trackEvent } from 'utils/analytics'
import { currentMRR, lineCount, totalTasks, totalUsers } from 'utils/transformers'

import github from 'assets/images/github_icon.svg'
import google from 'assets/images/ga_icon.svg'
import jira from 'assets/images/jira_icon.svg'
import stripe from 'assets/images/stripe_icon.svg'

import BarChart from 'components/BarChart'
import LineChart from 'components/LineChart'

const component = {
  github: p => 
    <BarChart
      indexBy='date'
      keys={['additions', 'deletions']}
      data={p}
      max={Math.max(...p.map(x => x.additions + x.deletions), 10)}
    />,
  google: p => <LineChart data={[{ id: 'google', data: p }]} max={Math.max(...p.map(x => x.y), 10)} />,
  jira: p => <LineChart data={[{ id: 'jira', data: p }]} max={Math.max(...p.map(x => x.y), 10)} />,
  stripe: p => <LineChart data={[{ id: 'stripe', data: p }]} max={Math.max(...p.map(x => x.y), 10)} />
}

const img = { github, google, jira, stripe }

const auth = {
  github: githubAuthURL,
  google: googleAuthURL,
  jira: jiraAuthURL,
  stripe: stripeAuthURL
}

const descriptor = {
  github: p => 'GitHub: ' + lineCount(p) + ' Changes',
  google: p => 'Google Analytics: ' + totalUsers(p) + ' Users',
  jira: p => 'Jira: ' + totalTasks(p) + ' Tasks',
  stripe: p => 'Stripe: ' + currentMRR(p) + ' MRR'
}

const text = {
  github: 'Connect to GitHub',
  google: 'Connect to Google Analytics',
  jira: 'Connect to Jira',
  stripe: 'Connect to Stripe'
}

const ev = service => ({
  ec: 'Service Integration',
  ea: 'Add Integration',
  el: service.capitalize()
})

const ChartCard = ({ service, ...props }) => (
  <div className='center full column'> 
    { props.hasService
      ?
      <>
        <div className='chart-header'>{ descriptor[service](props.data) }</div>
        { component[service](props.data) }
      </>
      :
      <a className='service-card' href={auth[service]} onClick={() => trackEvent(ev(service))}>
        <img className='service-img' src={img[service]} />
        { text[service] }
      </a>
    }
  </div>
)

export default memo(ChartCard)
